module.exports = __webpack_public_path__ + "img/first.62f0172f.png";